/** @graphql cc **/

import gql from 'graphql-tag';

// @phuang TODO: https://product-fabric.atlassian.net/browse/CTD-3710
export const IsSuperAdmin = gql`
	query IsSuperAdminQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				roles {
					isSuperAdmin
				}
			}
		}
	}
`;
